/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AgentId } from "../../commons/types/AgentId";
import { AccountId } from "../../commons/types/AccountId";
import { EnvironmentId } from "../../commons/types/EnvironmentId";
import { AgentConfig } from "./AgentConfig";
export const Agent = core.serialization
    .object({
    id: AgentId,
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
    accountId: AccountId,
    environmentId: EnvironmentId,
    createdFrom: AgentId.optional(),
    lastPropagatedAt: core.serialization.date().optional(),
})
    .extend(AgentConfig);
